import { observer } from 'mobx-react';
import { useCallback } from 'react';
import FilterButton from '../../FilterButton';
import { useAdvancedFilterContext } from '../../context';
import { AdvancedFilterProperties } from '../../types';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { localeStore } from 'src/mobx/localesStore';
import Icon from 'src/view/components/Controls/Icon/Icon';
import TimePicker from 'src/view/components/Controls/Pickers/TimePicker/TimePicker';
import { defaultTimeFrom, defaultTimeTo } from '~/constants/dateTime';
import './styles.scss';

interface TimeFilterModalProps {
  onClose: () => void;
}

const TimeFilterModal = ({ onClose }: TimeFilterModalProps) => {
  const { store } = useAdvancedFilterContext();

  const handleChangeTimeFrom = useCallback(
    (value: any) => {
      const _timeFrom = new Date(value).getTime();
      const _timeTo = store.selectedRanges[AdvancedFilterProperties.Time].get('to') || defaultTimeTo.getTime();
      store.selectRange(AdvancedFilterProperties.Time, { from: _timeFrom, to: _timeTo });
    },
    [store]
  );

  const handleChangeTimeTo = useCallback(
    (value: any) => {
      const _timeTo = new Date(value).getTime();
      const _timeFrom = store.selectedRanges[AdvancedFilterProperties.Time].get('from') || defaultTimeFrom.getTime();
      store.selectRange(AdvancedFilterProperties.Time, { from: _timeFrom, to: _timeTo });
    },
    [store]
  );

  const handleResetValues = useCallback(() => {
    store.resetPropertyValues(AdvancedFilterProperties.Time);
  }, [store]);

  const timeFromTimestamp = store.selectedRanges[AdvancedFilterProperties.Time].get('from');
  const timeToTimestamp = store.selectedRanges[AdvancedFilterProperties.Time].get('to');

  const timeFrom = timeFromTimestamp ? new Date(timeFromTimestamp) : defaultTimeFrom;
  const timeTo = timeToTimestamp ? new Date(timeToTimestamp) : defaultTimeTo;

  return (
    <div className="advanced-filter-time-modal">
      <div className="px-8 py-5">
        <h3 className="family-bold color-dark text-size-26">{localeStore.t('time_range')}</h3>
      </div>
      <div className="close-icon" onClick={onClose}>
        <Icon name={Icons.Close} size={10} />
      </div>
      <div className="d-flex flex-1 px-8 py-4 flex-column">
        <p className="time-label">{localeStore.t('from_time')}</p>
        <TimePicker className="pt-1" onTimeChanged={handleChangeTimeFrom} date={timeFrom} />
        <p className="time-label pt-4">{localeStore.t('to_time')}</p>
        <TimePicker className="pt-1" onTimeChanged={handleChangeTimeTo} date={timeTo} />
      </div>
      <div className="advanced-filter-buttons">
        <FilterButton title="apply" onClick={onClose} variant="primary" />
        <FilterButton title="txt_clear" onClick={handleResetValues} />
      </div>
    </div>
  );
};

export default observer(TimeFilterModal);
